import { FieldArray, Field } from 'redux-form';
import CitiesSelect from './Fields/CitiesSelect';
import CountrySelect from './Fields/CountrySelect';
import CourseSelect from './Fields/CourseSelect';
import DateView from './Fields/DateView';
import OfficesSelect from './Fields/OfficesSelect';

import { useTranslation } from 'react-i18next';
import BooleanSelect from './Fields/BooleanSelect';
import DaysSelect from './Fields/DaysSelect';
import DomainSelect from './Fields/DomainSelect';
import FranchStatusSelect from './Fields/FranchStatusSelect';
import GameTransactionsSelect from './Fields/GameTransactionsSelect';
import NewsStatusSelect from './Fields/NewsStatusSelect';
import QuizDisabledField from './Fields/QuizDisabledField';
import QuizStatusSelect from './Fields/QuizStatusSelect';
import RoleSelect from './Fields/RoleSelect';
import StatusCourse from './Fields/statusCourse';
import StatusSelect from './Fields/StatusSelect';
import StringArrayView from './Fields/StringArrayView';
import FieldNumber from './Fields/FieldNumber';
import StudentAgeGroupSelect from './Fields/StudentAgeGroupSelect';
import TeacherSelect from './Fields/TeacherSelect';
import TeachersNameselect from './Fields/TeachersNameselect';
import TeacherSupport from './Fields/TeacherSupport';
import HWTopicSelect from './Fields/HWTopicSelect';

export default ({ unique, item, index, ...props }) => {
    const { t } = useTranslation();
    switch (item.type) {
        case 'string':
        case 'price':
        case 'redirect':
        case '[phone]':
        case '[email]':
        case 'lang':
        case 'course_input':
        case 'LinkToSinlgeAndLang':
        case 'ellipsisText':
        case 'user_ids_array':
            return (
                <FieldArray
                    name={item.code}
                    label={t(item.label)}
                    component={StringArrayView}
                    placeholder={t(item.label)}
                    unique={unique}
                    data={item}
                    index={index}
                />
            );
        case 'number':
            return (
                <FieldArray
                    name={item.code}
                    label={t(item.label)}
                    component={FieldNumber}
                    placeholder={t(item.label)}
                    unique={unique}
                    data={item}
                    index={index}
                />
            );
        case 'date':
            return <DateView {...item} />;
        case 'status_course':
            return <StatusCourse {...item} />;
        case 'lesson_day':
            return <DaysSelect {...item} />;
        case 'course_select':
            return <CourseSelect {...item} />;
        case 'country_select':
            return <CountrySelect {...item} />;
        case 'cities_select':
            return <CitiesSelect {...item} />;
        case 'offices_select':
            return <OfficesSelect {...item} />;
        case 'teachers_select':
            return <TeacherSelect {...item} />;
        case 'status_select':
        case 'studentStatus':
        case 'status_select_teacher':
            return <StatusSelect {...item} />;
        case 'teachers_input':
            return <TeacherSupport {...item} />;
        case 'array_roles':
            return <RoleSelect {...item} />;
        case 'array_domains':
            return <DomainSelect {...item} />;
        case 'news_status':
            return <NewsStatusSelect {...item} />;
        case 'gameTransactions_select':
            return <GameTransactionsSelect {...item} />;
        case 'disabled_boolean':
            return <QuizDisabledField {...item} />;
        case 'status_select_quiz':
            return <QuizStatusSelect {...item} />;
        case 'teachersNameselect':
            return <TeachersNameselect {...item} />;
        case 'franch_status_select':
            return <FranchStatusSelect {...item} />;
        case 'boolean_select':
            return <BooleanSelect {...item} />;
        case 'age_select':
            return <StudentAgeGroupSelect {...item} />;
        case 'topic_select':
            return <HWTopicSelect {...item} />;

        default:
            return null;
    }
};
